import React, { useState, useEffect, useRef } from 'react';
import './BottomNavigation.css';

// ── BottomNavigation ──────────────────────────────────────────────────────────
// Five equal tabs: Home · Browse · Explore · List · More
// Penny Fox has moved off the nav bar (Phase 3 feature).
function BottomNavigation({ activeTab, onTabChange, basketCount = 0 }) {
  const [badgePulse, setBadgePulse] = useState(false);
  const prevCount = useRef(basketCount);
  useEffect(() => {
    if (basketCount > prevCount.current) {
      setBadgePulse(true);
      const t = setTimeout(() => setBadgePulse(false), 500);
      return () => clearTimeout(t);
    }
    prevCount.current = basketCount;
  }, [basketCount]);
  return (
    <nav className="bottom-nav" aria-label="Main navigation">

      {/* Home */}
      <button
        className={`nav-item ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => onTabChange('home')}
        aria-label="Home"
      >
        <svg className="nav-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polyline points="2,11 10,4 18,11"/>
          <rect x="4" y="11" width="12" height="7" rx="0.5"/>
          <path d="M8 18v-4h4v4"/>
        </svg>
        <span className="nav-label">Home</span>
        {activeTab === 'home' && <span className="nav-dot" aria-hidden="true" />}
      </button>

      {/* Browse */}
      <button
        className={`nav-item ${activeTab === 'browse' ? 'active' : ''}`}
        onClick={() => onTabChange('browse')}
        aria-label="Browse"
      >
        <svg className="nav-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="2" y="2" width="7" height="7" rx="1"/>
          <rect x="11" y="2" width="7" height="7" rx="1"/>
          <rect x="2" y="11" width="7" height="7" rx="1"/>
          <rect x="11" y="11" width="7" height="7" rx="1"/>
        </svg>
        <span className="nav-label">Browse</span>
        {activeTab === 'browse' && <span className="nav-dot" aria-hidden="true" />}
      </button>

      {/* Explore */}
      <button
        className={`nav-item ${activeTab === 'explore' ? 'active' : ''}`}
        onClick={() => onTabChange('explore')}
        aria-label="Explore"
      >
        <svg className="nav-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="10" cy="10" r="7.5"/>
          <polygon points="10,3.5 12,10 10,11.5 8,10" fill="currentColor" stroke="none"/>
          <polygon points="10,16.5 8,10 10,11.5 12,10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
        <span className="nav-label">Explore</span>
        {activeTab === 'explore' && <span className="nav-dot" aria-hidden="true" />}
      </button>

      {/* List */}
      <button
        className={`nav-item ${activeTab === 'basket' ? 'active' : ''}`}
        onClick={() => onTabChange('basket')}
        aria-label={`Shopping List${basketCount > 0 ? `, ${basketCount} items` : ''}`}
      >
        <span className="nav-icon-wrap">
          <svg className="nav-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M6 8.5L8 4.5"/>
            <path d="M14 8.5L12 4.5"/>
            <path d="M2 8.5h16l-1.2 7.5a1.5 1.5 0 01-1.5 1.25H4.7a1.5 1.5 0 01-1.5-1.25z"/>
          </svg>
          {basketCount > 0 && (
            <span className={`basket-badge${badgePulse ? ' basket-badge--pulse' : ''}`} aria-hidden="true">{basketCount}</span>
          )}
        </span>
        <span className="nav-label">List</span>
        {activeTab === 'basket' && <span className="nav-dot" aria-hidden="true" />}
      </button>

      {/* More */}
      <button
        className={`nav-item ${activeTab === 'more' ? 'active' : ''}`}
        onClick={() => onTabChange('more')}
        aria-label="More"
      >
        <svg className="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="5"  cy="12" r="1.5" fill="currentColor" stroke="none"/>
          <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"/>
          <circle cx="19" cy="12" r="1.5" fill="currentColor" stroke="none"/>
        </svg>
        <span className="nav-label">More</span>
        {activeTab === 'more' && <span className="nav-dot" aria-hidden="true" />}
      </button>

    </nav>
  );
}

export default BottomNavigation;
